import React from 'react';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-navy" data-id="element-21" data-mp="pjpx9t6ljn8q">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-22" data-mp="pm2eg44j5tkq">
        <div className="text-center" data-id="element-23" data-mp="aua6weaz9jtk">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-24" data-mp="at8v27m50tas">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-25" data-mp="1u5a0y3eu3tn">
            Five instant-use <span className="text-gold" data-id="element-26" data-mp="3o24ve2vg1zuu">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/75" data-id="element-27" data-mp="3o3y4dotj4w60">
            The volumes give you the season. These five get you using it before
            your next practice — so nothing sits unopened.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-28" data-mp="1r9l89ifsq54r">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`clip-corner flex flex-col overflow-hidden rounded-2xl border border-navy-line bg-navy-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-29" data-mp="3idmz7yg0j9gl" data-mpi={i}>
              <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="h-[230px] w-full border-b border-navy-line object-cover sm:h-[265px]" data-id="element-30" data-mp="3n5y8vt0k29mc" />
              <div className="px-5 pb-6 pt-4" data-id="element-31" data-mp="38hjzez8mvmwt">
                <div className="flex flex-wrap items-center gap-2" data-id="element-32" data-mp="33gnt6f0t7oo8">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-white/60" data-id="element-33" data-mp="33jidm6jtp9hn">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded bg-gold px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-ink" data-id="element-34" data-mp="iqexypq3tmjm">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 text-lg font-bold leading-snug text-white" data-id="element-35" data-mp="3hgg3vl62do8z">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-white/70" data-id="element-36" data-mp="3lhrunu0ocfir">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}